import * as React from "react";
import {Field, reduxForm, InjectedFormProps} from 'redux-form'
import {AppState} from "../../../store/app_state";
import {Action, Dispatch} from "redux";
import {connect} from "react-redux";

import {projectConfig} from "../../../../config/language/ja-JP/domain/model_text"
import FormGroupSelectConnectRf from "../../../common/molecular/form_group/form_group_select_connect_rf";
import {createNoRequiredOptionItem, createSelectItem} from "../../../../util/select_option_function";
import styled from "styled-components";
import {ConstBorderRound, ConstColor} from "../../../../config/styles_const/styles_const";
import HeadlineSmall from "../../../common/atom/text/headline_small";

const validate = (values: any) => {
    const errors: any = {};
    return errors;
};

interface IStateProps {

}

interface IProps extends IStateProps {
    handleOccupationChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handleWorkingHourRangeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handlePaymentRangeChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    handleWorkingDurationChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

interface IState {
    isFormOpen: boolean;
}

export class CustomerProjectsNarrowDownForm extends React.Component<IProps & InjectedFormProps<{}, IProps>, IState> {

    constructor(props: IProps & InjectedFormProps<{}, IProps>) {
        super(props);
        this.state = {
            isFormOpen: false,
        };
    }

    public render(): JSX.Element {

        const {
            handleOccupationChange,
            handleWorkingHourRangeChange,
            handlePaymentRangeChange,
            handleWorkingDurationChange
        } = this.props;

        const {isFormOpen} = this.state;

        return (

            <CustomerProjectsNarrowDownFormWrapper>
                <FormTitleWrapper>
                    <HeadlineSmall>条件で絞り込む</HeadlineSmall>
                    <ToggleIcon icon={"'\f1de'"} onClick={this.handleToggleIsFormOpen}/>
                </FormTitleWrapper>
                <FormWrapper isOpen={isFormOpen}>
                    <form
                        name="projectsSearchForm"
                        >
                        <FormInner>
                            <FormFieldCustomWrapper>
                                <Field
                                    name="occupation"
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    label="職種"
                                    onChange={handleOccupationChange}
                                >
                                    {createSelectItem(true, projectConfig.occupationList)}
                                </Field>
                            </FormFieldCustomWrapper>
                            <FormFieldCustomWrapper>
                                <Field
                                    name="workingHourRange"
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    label="時間（／月）"
                                    onChange={handleWorkingHourRangeChange}
                                >
                                    {createNoRequiredOptionItem(projectConfig.workingHourRangeList)}
                                </Field>
                            </FormFieldCustomWrapper>
                            <FormFieldCustomWrapper>
                                <Field
                                    name="paymentRange"
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    label="報酬 （／月）"
                                    onChange={handlePaymentRangeChange}
                                >
                                    {createNoRequiredOptionItem(projectConfig.paymentRangeList)}
                                </Field>
                            </FormFieldCustomWrapper>
                            <FormFieldCustomWrapper>
                                <Field
                                    name="workingDuration"
                                    component={FormGroupSelectConnectRf}
                                    type="text"
                                    label="稼働期間"
                                    onChange={handleWorkingDurationChange}
                                >
                                    {createNoRequiredOptionItem(projectConfig.workingDurationList)}
                                </Field>
                            </FormFieldCustomWrapper>

                        </FormInner>
                    </form>
                </FormWrapper>
            </CustomerProjectsNarrowDownFormWrapper>
        )
    };

    private handleToggleIsFormOpen = () => {
        this.setState({
            isFormOpen: !this.state.isFormOpen
        })
    }

}

const mapStateToProps = (state: AppState) => {
    return {};
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => {
    return {};
};

export default reduxForm<{}, IProps>({
    form: "CustomerProjectsSearchForm",
    validate,
})(connect(mapStateToProps, mapDispatchToProps)(CustomerProjectsNarrowDownForm));

const CustomerProjectsNarrowDownFormWrapper = styled.div`
    border-radius: ${ConstBorderRound.CornerRoundAll};
    margin-bottom: 30px;
`;

const FormTitleWrapper = styled.div`
    height: 60px;
    padding: 15px 20px;
    background: ${ConstColor.LightGray};
    border: 1px solid ${ConstColor.LightGray};
    border-radius: ${ConstBorderRound.CornerRoundLeftTopRightTop};
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ToggleIcon = styled(HeadlineSmall)`
    :hover {
        cursor: pointer;
    }
`;

const FormWrapper = styled.div<{isOpen: boolean}>`
    display: ${props => props.isOpen ? "block" : "none"};
    padding: 30px 30px 15px 30px;; 
    background: ${ConstColor.BgGray};
`;

const FormInner = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    flex-wrap: wrap;
`;

const FormFieldCustomWrapper = styled.div`
    width: 260px;
    margin-bottom: 15px;
`;

// const SubmitButton = styled(BtnCorporateMiddle)`
//     width: 100%;
// `;


// WEBPACK FOOTER //
// ./src/presentation/component/customer/projects/customer_projects_narrow_down_form.tsx